module.exports = __webpack_public_path__ + "static/media/projects.c557ab28.jpg";